import { Box, Button, Grid, Typography } from "@mui/material";
// import RootComponents from "../../../components/common/RootComponents";
import styles from "../Candidate.module.css";
// import TableCard from "../../../components/common/TableCard";
import { PiChatsFill } from "react-icons/pi";
import { LiaHeadsetSolid } from "react-icons/lia";
import { GoChecklist } from "react-icons/go";
import { BsFileEarmarkText } from "react-icons/bs";
import { BsFillJournalBookmarkFill } from "react-icons/bs";
import SearchCandidateList from "./SearchCandidateList";
import CandidateListingTable from "./CandidateListingTable";
import { customTextColor } from "../../../utils/const";
import { useNavigate } from "react-router-dom";
import { IoIosAdd } from "react-icons/io";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllCandidate,
  getAllRequirementCount,
} from "../../../redux/candidate/candidateSlice";
import {
  removeEducationSkill,
  removeOfficialReference,
  removePersonalDetails,
  removePreviousExperience,
} from "../../../redux/InternalStatic/internalCandidateStatic";
import TableCardNew from "../../../components/common/TableCardNew";
const CandidateListing = () => {
  const [allCandidates, setAllCandidates] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const allCandiadate = useSelector((state) => state.candidate.data);
  const allRequirementCount = useSelector((state) => state.candidate.countData);

  const [page, setPages] = useState(allCandiadate?.current_page || 1);
  const [pagination, setPagination] = useState({
    current_page: 1,
    has_next: false,
    has_previous: false,
    next_page: null,
    previous_page: null,
    total_pages: 1,
  });

  const [jobTitles, setJobTitles] = useState([]);

  const [searchData, setSearchData] = useState({
    current_location: [],
    end_date: "",
    start_date: "",
    current_job_title: [],
    full_name: "",
  });

  useEffect(() => {
    dispatch(getAllCandidate());
    dispatch(getAllRequirementCount());
    dispatch(removePersonalDetails());
    dispatch(removeEducationSkill());
    dispatch(removePreviousExperience());
    dispatch(removeOfficialReference());
  }, []);

  useEffect(() => {
    // if (allCandiadate?.profiles?.length > 0) {
    setAllCandidates(allCandiadate);
    // }
  }, [allCandiadate]);

  useEffect(() => {
    dispatch(getAllCandidate(`page=${page}`));
  }, [page]);

  const handleOnClear = () => {
    setSearchData({
      current_location: [],
      end_date: "",
      start_date: "",
      current_job_title: [],
      full_name: "",
    });
    dispatch(getAllCandidate());
  };

  useEffect(() => {
    if (allCandidates) {
      const jobTitle = allCandidates?.profiles
        ?.map((requirement) => requirement.current_job_title)
        .filter(
          (title, index, self) => title && self?.indexOf(title) === index
        ); // Remove duplicates and nulls
      setJobTitles(jobTitle);
    }
  }, [allCandidates]);

  const handleOnCLicksearch = () => {
    if (searchData) {
      const queryParams = Object.keys(searchData).reduce((acc, key) => {
        const value = searchData[key];
        console.log({ value });

        if (Array.isArray(value) && value.length > 0) {
          // Send arrays as JSON strings
          acc[key] = JSON.stringify(value);
        } else if (
          value !== "" &&
          value !== null &&
          value !== undefined &&
          !Array.isArray(value)
        ) {
          // Include non-empty strings or numbers
          acc[key] = value;
        }
        return acc;
      }, {});

      console.log("Filtered Query Params:", queryParams);

      // Convert queryParams into a query string
      const queryString = Object.entries(queryParams)
        .map(
          ([key, value]) =>
            `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
        )
        .join("&");

      console.log("Final Query String:", queryString);

      // Dispatch the action with the query string
      dispatch(getAllCandidate(queryString));
    } else {
      dispatch(getAllCandidate(""));
    }
  };

  console.log({ allCandidates });

  return (
    // <RootComponents>
    <Box className={styles.candidate_structure}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          bgcolor: "white",
          px: 1.5,
          mb: 1.5,
        }}
      >
        <Grid container gap={1.3}>
          <Grid item xs={12} sm={6} md={2.1}>
            <TableCardNew
              image={<BsFileEarmarkText className="card_icons" />}
              count={
                allCandidates?.total_resume_profiles
                  ? allCandidates?.total_resume_profiles
                  : 0
              }
              text="Candidates"
              // customStyle="10px 10px 0 10px; background-color: white;"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={2.1}>
            <TableCardNew
              image={<PiChatsFill className="card_icons" />}
              count={
                allRequirementCount?.requirements
                  ? allRequirementCount?.requirements
                  : 0
              }
              text="Requirements"
              customStyle={{ backgroundColor: "white" }}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={2.1}>
            <TableCardNew
              image={<GoChecklist className="card_icons" />}
              count={
                allRequirementCount?.submissions
                  ? allRequirementCount?.submissions
                  : 0
              }
              text="Submissions"
              // customStyle={{ backgroundColor: "white" }}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={2.1}>
            <TableCardNew
              image={<LiaHeadsetSolid className="card_icons" />}
              count={
                allRequirementCount?.interviews
                  ? allRequirementCount?.interviews
                  : 0
              }
              text="Interviews"
              // customStyle={{ backgroundColor: "white" }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={2.1}>
            <TableCardNew
              image={<BsFillJournalBookmarkFill className="card_icons" />}
              count={
                allRequirementCount?.placements
                  ? allRequirementCount?.placements
                  : 0
              }
              text="Placements "
              customStyle="10px 16px 0 5px; background-color: white;"
            />
          </Grid>
        </Grid>
        {allCandidates?.profiles?.length > 0 ? (
          <Button
            sx={{ textTransform: "capitalize", maxHeight: 50 }}
            onClick={() => navigate("/add-consultant")}
            variant="contained"
            color="info"
            size="large"
          >
            {" "}
            Candidate
            <IoIosAdd style={{ fontSize: "25px" }} />
          </Button>
        ) : (
          <Button
            sx={{ textTransform: "capitalize", maxHeight: 50 }}
            color="info"
            variant="contained"
            onClick={() => navigate("/add-candidate-public")}
            size="large"
          >
            {" "}
            Candidate
            <IoIosAdd style={{ fontSize: "25px" }} />
          </Button>
        )}
      </Box>

      <Box
        sx={{
          // padding: "5px 0 ",
          backgroundColor: "#fff",
          marginBottom: "14px",
        }}
      >
        {/* <SearchCandidateList /> */}
        <SearchCandidateList
          handleOnClear={handleOnClear}
          jobTitles={jobTitles}
          handleOnCLicksearch={handleOnCLicksearch}
          setSearchData={setSearchData}
          searchData={searchData}
        />
      </Box>
      <CandidateListingTable
        allCandidates={allCandidates}
        setPagination={setPagination}
        pagination={pagination}
        setPages={setPages}
        page={page}
      />
    </Box>
    // </RootComponents>
  );
};

export default CandidateListing;
